module.exports = __webpack_public_path__ + "static/media/lacross_icon-01.b958a816.png";